export const JWT_TOKEN = 'JWT_TOKEN';
export const CSRF_TOKEN = 'CSRF_TOKEN';
export const ADMIN_DETAIL = 'ADMIN_DETAIL';
export const NET__CONNECT = 'NET__CONNECT';
export const REFRESH_TOKEN = 'REFRESH_TOKEN';
export const COMMON_CONTENT = 'COMMON_CONTENT';